<template>
  <div class="wrap">
    <iframe
      v-if="show"
      class="box"
      scrolling="no"
      :src="`./pdf/web/viewer.html?file=${url}&watermark_text=${pdf_watermarkText}&is_encrypt=${is_encrypt}#page=1`"
    ></iframe>
    <div class="loading" v-if="loading">
      <el-progress
        type="circle"
        status="success"
        class="progress"
        v-if="currentRate == 100"
        :percentage="100"
      ></el-progress>
      <el-progress
        type="circle"
        class="progress"
        v-else
        :percentage="currentRate"
      ></el-progress>
    </div>
  </div>
</template>
<script>
import { OSS_URL } from "@/common/config";

export default {
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
    is_encrypt: {
      default: 1,
    },
    platform: {
      type: String,
      default: "h5",
    },
    watermarkText: {
      type: String,
      default: "搞一下",
    },
  },
  data() {
    return {
      loading: true,
      userInfo: {},
      show: false,
      currentRate: 0,
      interval: null,
    };
  },
  computed: {
    url() {
      if (this.is_encrypt) {
        return this.pdfUrl;
      }
      return this.pdfUrl.indexOf("http") > -1
        ? this.pdfUrl
        : OSS_URL + this.pdfUrl;
      // return "http://192.168.2.36:8080/Pig.pdf";
    },
    pdf_watermarkText() {
      return this.userInfo.phone
        ? this.userInfo.phone.replace(this.userInfo.phone.slice(3, 7), "****")
        : this.watermarkText;
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("user_info") || `{}`);
    this.show = true;
    this.interval = setInterval(() => {
      const currentRate = parseFloat(
        (this.currentRate + Math.random() * 10).toFixed(2)
      );
      this.currentRate = Math.min(currentRate, 95);
      if (this.currentRate >= 95) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }, 200);
    window.addEventListener("message", this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  methods: {
    onMessage(e) {
      if (e.data === "encry-pdf-loaded") {
        if (this.interval) {
          try {
            clearInterval(this.interval);
          } catch (e) {}
        }
        this.currentRate = 100;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
  },
};
</script>
<style scoped>
.wrap {
  width: 100vw;
  height: 100%;
  position: relative;
}

.box {
  width: 100vw;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.loading {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.progress {
  transform: scale(1.5);
}
</style>
